import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import { MakeRequired, useAppType } from "utils";

import { Icon, TagNormal } from "components";

type Filter = {
  title: string;
  icon?: string;
  filters?: Record<string, Filter>;
};

export type FilterSetProps = {
  onClearFilters: () => void;
  selectedFilters: string[];
  onSelectFilter: (key: string) => void;
  onUnselectFilter: (index: number) => void;
  filters: Record<string, Filter>;
};

export const FilterSet = ({ onClearFilters, selectedFilters = [], onSelectFilter, onUnselectFilter, filters }: FilterSetProps) => {
  const appType = useAppType();

  let lastFilter = { filters } as MakeRequired<Filter, "filters">;
  const appliedFilters: Filter[] = [];
  selectedFilters.forEach((setFilter) => {
    lastFilter = lastFilter.filters[setFilter] as MakeRequired<Filter, "filters">;
    appliedFilters.push(lastFilter);
  });

  const filterOptions = lastFilter.filters ? Object.entries(lastFilter.filters) : [];

  return (
    <ScrollContainer horizontal={appType.mobile} className="filter-container">
      <div className="filter">
        {appliedFilters.length > 0 && (
          <>
            <div className="kill-filter margin-right-50" data-testid="filter-clear">
              <Icon iconName="tabler/x" strokeWidth="xl" onClick={onClearFilters} />
            </div>
            <div>
              {appliedFilters.map((filter, index) => (
                <TagNormal
                  key={index}
                  type={index > 0 ? "sub-filter" : "main-filter"}
                  text={filter.title}
                  icon={filter.icon}
                  onClick={() => onUnselectFilter(index)}
                  dataTestId={`filter-${index > 0 ? "sub" : "main"}-${filter.title.toLowerCase().trim().replace(/\s/g, "-")}`}
                />
              ))}
            </div>
          </>
        )}
        {filterOptions.length > 0 && (
          <div>
            {filterOptions.map((filter) => {
              const filterOption = filter[1];
              return (
                <TagNormal
                  key={filter[0]}
                  type="option-filter"
                  text={filterOption.title}
                  onClick={() => onSelectFilter(filter[0])}
                  icon={filterOption.icon}
                  dataTestId={`filter-${filterOption.title.toLowerCase().trim().replace(/\s/g, "-")}`}
                />
              );
            })}
          </div>
        )}
      </div>
    </ScrollContainer>
  );
};
